import { render, staticRenderFns } from "./MaterialPropertyList.vue?vue&type=template&id=74797b90&scoped=true"
import script from "./MaterialPropertyList.vue?vue&type=script&lang=js"
export * from "./MaterialPropertyList.vue?vue&type=script&lang=js"
import style0 from "./MaterialPropertyList.vue?vue&type=style&index=0&id=74797b90&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74797b90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74797b90')) {
      api.createRecord('74797b90', component.options)
    } else {
      api.reload('74797b90', component.options)
    }
    module.hot.accept("./MaterialPropertyList.vue?vue&type=template&id=74797b90&scoped=true", function () {
      api.rerender('74797b90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/material/MaterialPropertyList.vue"
export default component.exports